var map = {
	"./datapicker/datepicker.json": "./src/libs/i18n/locales/datapicker/datepicker.json",
	"./en.json": "./src/libs/i18n/locales/en.json",
	"./es.json": "./src/libs/i18n/locales/es.json",
	"./pt.json": "./src/libs/i18n/locales/pt.json",
	"./timepicker/timepicker.json": "./src/libs/i18n/locales/timepicker/timepicker.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/libs/i18n/locales sync recursive [A-Za-z0-9-_,\\s]+\\.json$/";